import { Injectable } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { Observable, pipe, Subject, UnaryFunction } from 'rxjs';
import { delay, tap } from 'rxjs/operators';
import { ProgressIndicatorComponent } from '../components/progress-indicator/progress-indicator.component';
import { ProgressData } from '../dtos/progress-data';

export interface ProgressIndicatingComponentParams {
    progress$: Observable<ProgressData>,
    initial: ProgressData
}

@Injectable({
    providedIn: 'root'
})
export class ProgressIndicatingService {
    public constructor(private dialogService: DialogService) {}

    public show(progressIndicatingComponentParams: ProgressIndicatingComponentParams): void {
        this.dialogService.open(ProgressIndicatorComponent, {
            closable: false,
            modal: true,
            showHeader: false,
            data: progressIndicatingComponentParams
        });
    }
}

export function progressTap<T>(progress$: Subject<ProgressData>, progressData: ProgressData): UnaryFunction<Observable<T>, Observable<T>> {
    return pipe(
        tap(() => progress$.next({
            header: progressData.header,
            details: progressData.details,
            done: progressData.done
        })),
        delay(1000));
}
